import {
  Crosshair,
  EyeOff,
  GanttChart,
  Globe,
  Map,
  Shield,
  SwordsIcon,
  Video,
} from 'lucide-react';
import React from 'react';

interface PackageFeature {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const packageFeatures: PackageFeature[] = [
  {
    icon: <Globe size={16} strokeWidth={1} />,
    title: 'Available Worldwide',
    description: 'You can utilize SCL from any part of the world.',
  },
  {
    icon: <SwordsIcon size={16} strokeWidth={1} />,
    title: 'Scrim Servers',
    description:
      '5v5 match setup available to use at all times, for all teams.',
  },
  {
    icon: <Video size={16} strokeWidth={1} />,
    title: 'Demo Recording',
    description: 'You can enable demo recordings for all your matches.',
  },
  {
    icon: <Map size={16} strokeWidth={1} />,
    title: '2D Demo Viewer',
    description:
      'Improve using our 2D Replay feature, available for all demos.',
  },
  {
    icon: <Crosshair size={16} strokeWidth={1} />,
    title: 'Practice Mode',
    description: 'Find lineups, grenades, and strategies using practice mode.',
  },
  {
    icon: <Shield size={16} strokeWidth={1} />,
    title: 'Retake Mode',
    description: 'Improve your post-plant abilities using the retake mode.',
  },
  {
    icon: <GanttChart size={16} strokeWidth={1} />,
    title: 'Analytics',
    description: 'Track your teams progress using the analytics tool.',
  },
  {
    icon: <EyeOff size={16} strokeWidth={1} />,
    title: 'Private Server',
    description: 'All our servers are hidden from outside espionage.',
  },
];

const SCLPackage: React.FC = () => (
  <section className="mx-auto max-w-5xl px-6 py-12 sm:py-24 md:max-w-7xl">
    <div className="flex flex-col items-center">
      <div className="mb-8 font-codeSaver uppercase text-primary">
        The scl package
      </div>
      <h2 className="mb-16 max-w-2xl text-balance text-center text-3xl font-semibold sm:text-4xl">
        We offer all team members everything they need in one place
      </h2>
      <div className="grid grid-cols-1 gap-5 rounded-md border p-8 sm:grid-cols-3 sm:p-14 md:grid-cols-4">
        {packageFeatures.map((item, index) => (
          <div key={index} className="flex flex-col rounded-md p-4">
            <div className="max-w-max rounded-md bg-card p-2.5 text-primary">
              {item.icon}
            </div>
            <h4 className="mt-4 font-semibold">{item.title}</h4>
            <p className="mt-2 text-sm text-muted-foreground">
              {item.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default SCLPackage;
